const targetForm = document.querySelector('.ns-micro-enterprise-merchant-form');

const handleSubmit = (e) => {
    grecaptcha.ready(() => {
        grecaptcha.execute(window.SiteKey, {action: `NsMicroEnterpriseMerchant${location.pathname.replace(/[^A-Za-z\/_]/g, `_`)}`}).then((token) => {
            const formData = new FormData(targetForm);
            formData.append('recaptcha', token);

            //get phone with code in correct field from hidden technical
            formData.set("NsMicroEnterpriseMerchantForm[contactPhone]", formData.get("phone_full"));

            const xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 1) {
                    targetForm.classList.add("ns-form__processing");
                }
            };
            xhr.onload = () => {

                const data = JSON.parse(xhr.response);

                if (data.modelValidationErrors.length === 0) {
                    // To prevent ad blockers from blocking user redirects, setTimeout is used
                    setTimeout(
                        () => {
                            targetForm.classList.remove("ns-form__processing");
                            document.location.href = targetForm.dataset.actionSuccess;
                        },
                        1000
                    );
                    gaSimplePush({
                        'conversion_name': window.conversionName,
                        'conversion_step': data.params.conversion_step,
                        'formCountry': data.params.formCountry,
                        'formTurnover': data.params.formTurnover,
                        'conversion_param': data.params.conversion_param,
                        'eventCallback': () => {
                            document.location.href = targetForm.dataset.actionSuccess;
                        },
                    }, 'Success', 'en_EN');

                    return false;
                } else {
                    targetForm.classList.remove("ns-form__processing");
                    for (const modelValidationErrorKey in data.modelValidationErrors) {
                        const helpBlock = targetForm.querySelector(
                            `.field-nsmicroenterprisemerchantform-${modelValidationErrorKey} .help-block`.toLowerCase()
                        );
                        helpBlock.textContent = data.modelValidationErrors[modelValidationErrorKey][0];
                    }

                    return false;
                }
            };
            xhr.open('POST', $(targetForm).attr(`action`));
            xhr.send(formData);
        });
    });

    return false;
}

const autosetIndustryId = (e) => {
    const industry = targetForm.querySelector(".ns-form-industry-id .form-control");
    const matchData = document.querySelector(".ns-micro-enterprise-merchant-form__industry-and-segment-matching");
    const matchTableObj = JSON.parse(matchData.textContent);
    industry.value = matchTableObj[e.target.value];
}

const autosetMerchantResidence = () => {
    const merchantResidence = targetForm.querySelector(".ns-form-merchant-residence .form-control");
    merchantResidence.selectedIndex = 1;
}

const autosetMerchantTitle = (e) => {
    const merchantTitle = targetForm.querySelector(".ns-form-merchant-title .form-control");
    merchantTitle.value = e.target.value;
}

const init = () => {
    if (!targetForm) {
        return;
    }

    autosetMerchantResidence();
    const segmentId = targetForm.querySelector(".ns-form-segment-id .form-control");
    segmentId.addEventListener('change', autosetIndustryId, false);
    const legalEntityTitle = targetForm.querySelector(".ns-form-legal-entity-title .form-control");
    legalEntityTitle.addEventListener('change', autosetMerchantTitle, false);
    $(targetForm).on('beforeSubmit', handleSubmit);
}

window.addEventListener('DOMContentLoaded', init, false);
